/** @description always include jQuery in this manner in every file where jQuery is used */

import Global from './global';

const $ = jQuery.noConflict();

'use strict';
const Chat = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domChatLink: $('.js-chat'),

	/** @description Initialize */
	init: function() {
		// uncomment this to turn tidio on
		if ($('.js-chat').length) {
			this.openChat();
		}
	},

	/** @description slider example description e.g Banner slider */
	openChat: function() {
		let chatChecker = false;
		Chat.$domChatLink.on('click', function(e) {
			e.preventDefault();
			if (!chatChecker) {
				chatChecker = true;
				Global.functions.addScript('https://code.tidio.co/fqxnjfktk6akixdzhnbutu3a3l6y3qtp.js', false, function() {
					setTimeout(() => {
						Chat.triggerChatOpen();
					}, 1000);
				});
			} else {
				Chat.triggerChatOpen();
			}
		});
	},

	triggerChatOpen: function() {
		const el = document.getElementById('tidio-chat-iframe');
		const btn = el.contentWindow.document.getElementById('button-body');
		$(btn).trigger('click');
	},

	loadTidioScript() {
		Global.functions.addScript('https://code.tidio.co/fqxnjfktk6akixdzhnbutu3a3l6y3qtp.js');
	}
};

export default Chat;
